import { CustomShowToastProps } from "../hooks/custom-toast";

type ToastFunction = (props: CustomShowToastProps) => void;

interface IToastFunctions {
  success: ToastFunction;
  error: ToastFunction;
  warning: ToastFunction;
  info: ToastFunction;
}

let toastFunctions: IToastFunctions | null = null;

export const ToastService = {
  init: (functions: IToastFunctions) => {
    toastFunctions = functions;
  },

  success: (props: CustomShowToastProps) => {
    if (toastFunctions) {
      toastFunctions.success(props);
    }
  },

  error: (props: CustomShowToastProps) => {
    if (toastFunctions) {
      toastFunctions.error(props);
    }
  },

  warning: (props: CustomShowToastProps) => {
    if (toastFunctions) {
      toastFunctions.warning(props);
    }
  },

  info: (props: CustomShowToastProps) => {
    if (toastFunctions) {
      toastFunctions.info(props);
    }
  }
};
